import React from 'react'
import { IconAccount } from '../../../../../shared/icon/icon'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { Form, FormEmail, FormText, FormSubmit } from '../../../../../shared/form/form'
import { Card } from '../../../../../shared/card/card'
import { useApiFormLoginSettings } from '../../../../../api-new/state/auth'
import { MyAIToolsSharing } from '../../../../../shared/ai-tools-sharing/my-ai-tools-sharing'
import { consentAvailable } from '../../../../../shared/ai-tools-sharing/consent-api'

export const LoginSetting = () => {
  const apiFormLoginSettings = useApiFormLoginSettings()

  const handleMatch = () => apiFormLoginSettings.get()

  const handleSubmit = async data => await apiFormLoginSettings.put(data.id, data)

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAccount} text="Your account" onMatch={handleMatch}>
        <Card title="Your account">
          <Form state={apiFormLoginSettings.form} submitting={apiFormLoginSettings.submitting} onSubmit={handleSubmit}>
            <FormEmail label="email" name="email" required readOnly />
            <FormText label="first name" name="firstName" required />
            <FormText label="last name" name="lastName" required />
            <FormSubmit text="update" />
          </Form>
        </Card>
        {/* The AI tools sharing question, as the tools ask it (consent
            visibility, owner-approved 2026-10-23). */}
        {consentAvailable() &&
          <section aria-label="AI tools sharing">
            <Card title="AI tools sharing">
              <MyAIToolsSharing />
            </Card>
          </section>}
      </BreadcrumbView>
    </React.Fragment>
  )
}
